const INITIAL_STATE = {
    areaVirtualPaged: {},
    areaVirtual: {},
    aviexpPaged: {},
    positionPaged: {},
    positions: [],
    containers: [],
    unloadLocationPaged: {},
    unloadLocation: {},
    maritimeCompanyPaged: {},
    maritimeCompany: {},
    harborPaged: {},
    containerStatus: [],
    harbor: {},
    harborList: [],
    freetimePaged: {},
    freetime: {},
    maritimeCompanyList: [],
    coveragePartNumberPaged: {},
    coveragePartNumber: {},
    mdr: {},
    mdrList: [],
    containerHistoryListPaged: [],
    containersItemPaged: [],
    containersItemPartNumberPaged: [],
    alertsEmailPaged: [],
    coveragePaged: [],
    partNumberSupplier: {},
    partNumberSupplierList: [],
};

export default function configReducer(state, action) {

    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'SET_AREA_VIRTUAL_PAGED': {
            return {
                ...state,
                areaVirtualPaged: action.areaVirtualPaged
            };
        }
        case 'SET_AREA_VIRTUAL': {
            return {
                ...state,
                areaVirtual: action.areaVirtual
            };
        }
        case 'SET_POSITION_PAGED': {
            return {
                ...state,
                positionPaged: action.positionPaged
            };
        }
        case 'SET_UNLOAD_LOCATION_PAGED': {
            return {
                ...state,
                unloadLocationPaged: action.unloadLocationPaged
            };
        }
        case 'SET_UNLOAD_LOCATION_ALL': {
            return {
                ...state,
                unloadLocationList: action.unloadLocationList
            };
        }
        case 'SET_UNLOAD_LOCATION': {
            return {
                ...state,
                unloadLocation: action.unloadLocation
            };
        }
        case 'SET_AVIEXP_PAGED': {
            return {
                ...state,
                aviexpPaged: action.aviexpPaged
            };
        }
        case 'SET_CONTAINER_PAGED': {
            return {
                ...state,
                containers: action.containerPaged
            };
        }
        case 'SET_CONTAINER': {
            return {
                ...state,
                container: action.container
            };
        }
        case 'SET_CRITICAL_PART': {
            return {
                ...state,
                criticalPart: action.item
            };
        }
        case 'SET_CRITICAL_PARTS_PAGED': {
            return {
                ...state,
                criticalPartNumbers: action.itemsPaged
            };
        }
        case 'SET_CRITICAL_PARTS_FILTERS': {
            return {
                ...state,
                filters: action.filters
            };
        }
        case 'SET_CRITICAL_PART_EMAILS': {
            return {
                ...state,
                criticalPartsEmails: action.items
            };
        }
        case 'SET_CONTAINER_TYPES': {
            return {
                ...state,
                containerTypes: action.items
            };
        }
        case 'SET_CONTAINER_STATUS': {
            return {
                ...state,
                containerStatus: action.items
            };
        }
        case 'SET_CONTAINER_TYPE': {
            return {
                ...state,
                containerType: action.item
            };
        }
        case 'SET_CONTAINER_SIZES': {
            return {
                ...state,
                containerSizes: action.items
            };
        }
        case 'SET_CONTAINER_SIZE': {
            return {
                ...state,
                containerSize: action.item
            };
        }
        case 'SET_PLANT_CONFIG': {
            return {
                ...state,
                plantConfig: action.item
            };
        }
        case 'SET_BUSINESS_HOURS_CONFIG': {
            return {
                ...state,
                businessHoursConfig: action.item
            };
        }
        case 'SET_MARITIME_COMPANY_ALL': {
            return {
                ...state,
                maritimeCompanyList: action.maritimeCompanyList
            };
        }
        case 'SET_POSITIONS_ALL': {
            return {
                ...state,
                positions: action.positions
            };
        }
        case 'SET_MARITIME_COMPANY_PAGED': {
            return {
                ...state,
                maritimeCompanyPaged: action.maritimeCompanyPaged
            };
        }
        case 'SET_MARITIME_COMPANY': {
            return {
                ...state,
                maritimeCompany: action.maritimeCompany
            };
        }
        case 'SET_HARBOR_ALL': {
            return {
                ...state,
                harborList: action.harborList
            };
        }
        case 'SET_HARBOR_PAGED': {
            return {
                ...state,
                harborPaged: action.harborPaged
            };
        }
        case 'SET_HARBOR': {
            return {
                ...state,
                harbor: action.harbor
            };
        }
        case 'SET_COVERAGE_PARTNUMBER_PAGED': {
            return {
                ...state,
                coveragePartNumberPaged: action.coveragePartNumberPaged
            };
        }
        case 'SET_COVERAGE_PARTNUMBER': {
            return {
                ...state,
                coveragePartNumber: action.coveragePartNumber
            };
        }

        case 'SET_FREETIME_PAGED': {
            return {
                ...state,
                freetimePaged: action.freetimePaged
            };
        }
        case 'SET_FREETIME': {
            return {
                ...state,
                freetime: action.freetime
            };
        }
        case 'SET_MDR_PAGED': {
            return {
                ...state,
                mdrList: action.mdrPaged
            };
        }
        case 'SET_MDR': {
            return {
                ...state,
                mdr: action.mdr
            };
        }
        case 'SET_CONTAINER_HISTORY_PAGED': {
            return {
                ...state,
                containerHistoryListPaged: action.containerHistoryListPaged
            };
        }
        case 'SET_CONTAINER_ITEM_PAGED': {
            return {
                ...state,
                containersItemPaged: action.containerItemPaged
            };
        }
        case 'SET_CONTAINER_ITEM_PARTNUMBER_PAGED': {
            return {
                ...state,
                containersItemPartNumberPaged: action.containersItemPartNumberPaged
            };
        }
        case 'SET_ALERT_EMAIL_PAGED': {
            return {
                ...state,
                alertsEmailPaged: action.alertsEmailPaged
            };
        }
        case 'SET_COVERAGE_PAGED': {
            return {
                ...state,
                coveragePaged: action.coveragePaged
            };
        }
        case 'SET_PARTNUMBER_SUPPLIER_PAGED': {
            return {
                ...state,
                partNumberSupplierList: action.partNumberSupplierPaged
            };
        }
        case 'SET_PARTNUMBER_SUPPLIER': {
            return {
                ...state,
                partNumberSupplier: action.partNumberSupplier
            };
        }
        default:
            return state;
    }
}
